import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement> & { fill?: string };

const ShareIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0381 12.1967V9.96702C11.5413 9.96702 10.817 10.6783 9.07655 13.9987C9.07655 13.9987 7.7609 6.99965 16.0381 6.99965V4.91733C16.0381 4.52116 16.4769 4.28235 16.8096 4.49744L22.3597 8.08567C22.662 8.28115 22.6649 8.7225 22.3651 8.92189L16.815 12.613C16.4827 12.834 16.0381 12.5958 16.0381 12.1967ZM5 7.99965C5 7.44736 5.44772 6.99965 6 6.99965H9C9.55228 6.99965 10 6.55193 10 5.99965C10 5.44736 9.55228 4.99965 9 4.99965H6C4.34315 4.99965 3 6.34279 3 7.99965V15.9996C3 17.6565 4.34315 18.9996 6 18.9996H18C19.6569 18.9996 21 17.6565 21 15.9996V13.7139C21 13.1616 20.5523 12.7139 20 12.7139C19.4477 12.7139 19 13.1616 19 13.7139V15.9996C19 16.5519 18.5523 16.9996 18 16.9996H6C5.44772 16.9996 5 16.5519 5 15.9996V7.99965Z"
    />
  </svg>
));

export default ShareIcon;
